export enum SyncConfigTypes {
  GET_SYNC_OPERATIONS = '@@syncConfig/GET_SYNC_OPERATIONS',
  GET_SYNC_OPERATIONS_SUCCESS = '@@syncConfig/GET_SYNC_OPERATIONS_SUCCESS',
  GET_SYNC_OPERATIONS_FAIL = '@@syncConfig/GET_SYNC_OPERATIONS_FAIL',

  ADD_SYNC_OPERATIONS = '@@syncConfig/ADD_SYNC_OPERATIONS',
  ADD_SYNC_OPERATIONS_SUCCESS = '@@syncConfig/ADD_SYNC_OPERATIONS_SUCCESS',
  ADD_SYNC_OPERATIONS_FAIL = '@@syncConfig/ADD_SYNC_OPERATIONS_FAIL',

  DELETE_SYNC_OPERATIONS = '@@syncConfig/DELETE_SYNC_OPERATIONS',

  UPDATE_SYNC_OPERATIONS = '@@syncConfig/UPDATE_SYNC_OPERATIONS',
}
